import React, { useEffect, useState } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { createStreamIQApiService } from '@/api/streemiq/createStreamIQApiService'
import { Box } from '@mui/material'
import { pollingInterval } from '@/shared/constants'
import {
    saveToLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'

export const QRCodeLogin: React.FC = () => {
    const [qrCodeUrl, setQRCodeUrl] = useState('')
    const [loginId, setLoginId] = useState('')
    const [polling, setPolling] = useState(false)

    useEffect(() => {
        const fetchQRCode = async () => {
            const data = await createStreamIQApiService().requestQRCode()
            setQRCodeUrl(data.url)
            setLoginId(data.id)
            setPolling(true)

            saveToLocalStorage(sessionTokenLsKeyword, data.IdToken)
        }

        fetchQRCode()
    }, [])

    // Polling to check if login is completed
    useEffect(() => {
        if (polling) {
            const interval = setInterval(async () => {
                try {
                    // const response =
                    //     await createStreamIQApiService().signInWithQRCode(
                    //         loginId
                    //     )
                    // if (response.data.credentialId) {
                    //     setPolling(false)
                    // }
                } catch (err) {
                    console.log('Polling error', err)
                }
            }, pollingInterval)

            return () => clearInterval(interval)
        }
    }, [polling, loginId])

    return (
        <Box>
            {qrCodeUrl ? (
                <QRCodeSVG value={qrCodeUrl} size={256} />
            ) : (
                <p>Loading QR Code...</p>
            )}
        </Box>
    )
}
